// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Assest/Svg/DashboardWelcomeImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_I0fOc {
  margin-top: 10px;
  width: 100%;
}
.cardContent_fSc1A {
  margin: -10px;
}
.col_FfKf7 {
  display: flex;
  flex-direction: column;
}
.marginTop10_TOexI {
  margin-top: 10px;
}
.marginTop5_oGoGi {
  margin-top: 5px;
}
.marginRight10_TPJhB {
  margin-right: 10px;
}
.marginLeft10_ACTtz {
  margin-left: 10px;
}
.displayflex_mBYNn {
  display: flex;
}
.tittle_NTplU {
  font-size: 24px;
  font-weight: 600;
  color: #3a3541;
  margin-top: 0px;
}
.textAlignRight_C5FAk {
  text-align: right;
}
.welcome_N9WQ5 {
  justify-content: space-between;
}
.welcome__div_QpU1C {
  display: flex;
  flex-direction: row;
  margin-top: 0px;
  font-size: 18px;
}
.welcome__div__largeText_rAxQE {
  font-size: 16px;
  color: #718096;
  font-weight: 600;
  margin: auto;
}
.welcome__div__largeText_name_TgYm1 {
  font-size: 16px;
  color: #306bff;
  font-weight: 600;
}
.welcome__div__smallText_SWjNL {
  font-size: 14px;
  color: #4d5770;
  font-weight: 500;
  margin: auto;
}
.headLines__left_iZGmF {
  background-color: #e8f1ff;
  border-radius: 10px;
}
.headLines__left__textDivOne_Oxjjs {
  width: 100%;
  margin-left: 10px;
}
.headLines__left__textDiv__backgroundImage_IVivW {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -75% 140%;
  height: 100%;
  width: 100%;
}
.headLines__left__textDivOne_text_Gd1V4 {
  font-weight: 500;
  font-size: 16px;
  color: #1a1d3c;
}
.headLines__left__textDivTwo_HCKfc {
  width: 100%;
  margin-left: 10px;
  margin-top: -10px;
}
.headLines__left__textDivTwo_text_eVZB5 {
  font-weight: 500;
  font-size: 12px;
  color: #4d5770;
}
.headLines__left__textDivOne__text__name_yUMgK {
  font-weight: 700;
  color: #ffc061;
}
.headLines__right_orC2C {
  max-height: 124px;
}
.headLines__right__row_Veu6q {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  margin-left: 20px;
  margin-bottom: 0px;
}
.headLines__right__row__headline_dbiXU {
  font-size: 20px;
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 0px;
  color: #25396f;
  line-height: 32px;
}
.headLines__right__row__headline__arrow_n4Hko {
  position: absolute;
  right: 0px;
  top: 2px;
}
.headLines__right__row__headline__arrow__button_FZbjc {
  display: contents;
  margin-top: auto;
}
.headLines__right__row__tittle_fkrf1 {
  font-size: 16px;
  font-weight: 600;
  color: #364459;
  margin-bottom: 0px;
}
.headLines__right__row__description_IHgX5 {
  font-size: 16px;
  font-weight: 400;
  color: #667085;
  margin-bottom: 0px;
}
.client__card__height_wMLsv {
  height: 320px;
}
.over__card__height_LCG6I {
  height: 360px;
}
.clients__first__left_uxDsu {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #364459;
  padding-right: 10px;
}
.client__first__middle_g_pZi {
  text-align: end;
}
.client__first__middle__text_hxXqT {
  font-size: 14px;
  font-weight: 700;
  color: #718096;
  margin-top: 15px;
}
.client__first__middle__count_g1e6D {
  font-size: 24px;
  font-weight: 700;
  color: #25396f;
  margin-top: 3px;
  margin-left: 10px;
}
.client__first__right_QM8Ht {
  text-align: end;
}
.client__second_n4hFc {
  display: flex;
  flex-direction: row;
  margin-top: 6px;
  overflow-wrap: anywhere;
}
.client__second__col_PQ5GH {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.client__second__number_M5m5b {
  text-align: center !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px;
}
.client__second__number__tag_AczVz {
  font-size: 11px;
  font-weight: 600;
  color: #000000 !important;
  line-height: 14px;
}
.client__second__name_MS1x4 {
  font-size: 1px;
  font-weight: 500;
}
.client__third_hZASb {
  position: relative;
  height: 100% !important;
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
}
.missingInfo__main__height_gui5y {
  height: 360px;
}
.missingInfo__first__left_ZSFd6 {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #364459;
  margin-top: -10px;
}
.missingInfo__first__middle_M4gJw {
  text-align: end;
}
.missingInfo__first__middle__text_XftXh {
  font-size: 14px;
  font-weight: 700;
  color: #718096;
}
.missingInfo__first__middle__count_sapfx {
  font-size: 24px;
  font-weight: 700;
  color: #25396f;
  margin-top: -5px;
}
.missingInfo__first__right_qAx_W {
  text-align: end;
}
.missingInfo__second_R2vpQ {
  margin-top: 20px;
}
.missingInfo__second__row_hv_au {
  font: caption;
  display: flex;
  align-items: center;
  justify-content: center;
}
.missingInfo__second__row__first__col_KAnop {
  font-size: 14px;
  color: #33529a;
  font-weight: 500;
  line-height: 17px;
}
.missingInfo__second__row__second__col_Ivsyn {
  text-align: end;
  font-size: 18px;
  color: #49849d;
  font-weight: 600;
  line-height: 22px;
}
.icController__main__height_UjNXV {
  height: 360px;
}
.icController__select_Cd6fy {
  background-color: #f6f6f6;
  border-radius: 10px;
}
.icController__first_s0xC2 {
  display: flex;
  align-items: center;
}
.icController__first__tittle_Au_ro {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #364459;
}
.icController__second_u3HBc {
  display: flex;
  align-items: center;
}
.icController__third_ynVMf {
  display: flex;
  align-items: center;
  justify-content: end;
}
.icController__chart__first_BoVqO {
  margin-top: 10px;
  align-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0%;
}
.icController__chart__second_s5we2 {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 10px;
}
.icController__chart__second__col_mUDKO {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 10px;
}
.icController__chart__second__col__firstDiv_Js6ku {
  font-size: 13px;
  font-weight: 400;
  color: #83838d;
  text-align: center;
}
.icController__chart__second__col__secondDiv_nIDtZ {
  font-size: 20px;
  font-weight: 500;
  color: #47484a;
  text-align: center;
}
.todo__main__height_5htUW {
  height: 800px;
}
.todo__tab__one_aVuxt {
  margin-top: 20px;
  color: #4d5770;
  font-weight: 500;
  font-size: 10px;
}
.todo__tab__one__tag_uScC5 {
  width: 70px;
  height: 20px;
  color: #364459;
  text-align: center;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
}
.todo__tab__one__badge_leGt_ {
  height: 10px;
  color: #364459;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
.todo__tab__two__main__active_L_QTH {
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #306bff;
  cursor: pointer;
}
.todo__tab__two__main__inactive_DjwkT {
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #a0aec0;
  cursor: pointer;
}
.todo__tab__two__main__right_OcdMd {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #306bff;
  text-align: end;
  cursor: pointer;
}
.todo__list__main_QCWuL {
  width: 100%;
  margin-top: 10px;
}
.todo__list__main__item__main_s8FSA {
  width: 100%;
}
.todo__list__main__item__main__tittle_X_C5R {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: #364459;
}
.todo__list__main__item__main__first__content_NQuNS {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #718096;
  margin-bottom: 6px;
  margin-top: 6px;
}
.todo__list__second__item__tittle_MsupX {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #718096;
  margin-bottom: 6px;
  margin-top: 6px;
}
.todo__list__third__item__first__tittle_SJINp {
  width: 100%;
  font-size: 11px;
  font-weight: 400;
  color: #718096;
}
.todo__list__third__item__second__tittle_O13Bk {
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 10px;
  font-weight: 400;
  color: #718096;
}
.todo__last__item__main_ZDKGi {
  display: flex;
  flex-direction: column;
  text-align: end;
}
.todo__last__item__button_MQCku {
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  line-height: 23px;
  align-self: flex-end;
}
.todo__last__item__icons_bMRQy {
  margin-top: 5px;
}
.toFollow__main__height_rnxYk {
  height: 440px;
}
.toFollow__select_IP46D {
  width: 120px;
  background-color: #f6f6f6;
  border-radius: 10px;
}
.toFollow__viewAll_xXKJy {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #306bff;
  text-align: end;
  cursor: pointer;
}
.toFollow__tab__active_cgs22 {
  font-size: 13px;
  font-weight: 400;
  color: #ffffff;
}
.toFollow__tag__active_QkygL {
  background-color: #3e8eff;
}
.toFollow__tab__inactive_hzQCC {
  font-size: 13px;
  font-weight: 400;
  color: #1a1d3c;
  padding: 2px !important;
}
.toFollow__chart__main_GOnIQ {
  margin-top: 10px;
  align-content: center;
  position: relative;
  width: 100%;
  height: 200px;
  top: 0%;
  left: 0%;
}
.toFollow__chart__text_FINzq {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #364459;
  text-align: center;
}
.toFollow__chart__text_count_oryGK {
  font-size: 20px;
  font-weight: 500;
}
.toFollow__chart__text_count_text___8Py {
  font-size: 15px;
  font-weight: 400;
  -webkit-text-decoration: dashed !important;
          text-decoration: dashed !important;
}
.staffProgress__main__height_BBQvs {
  height: auto;
}
.staffProgress__tittle_l8sji {
  font-size: 20px;
  font-weight: 600;
  color: #364459;
  line-height: 32px;
}
.staffProgress__viewall_P895S {
  font-size: 14px;
  font-weight: 500;
  color: #306bff;
  line-height: 20px;
  align-self: center;
  text-align: end;
  cursor: pointer;
}
.staffProgress__table_V1FOJ {
  margin-top: 10px;
  width: 100%;
}
.staffProgress__search_slqM1 {
  width: 350px;
  margin-top: 10px;
  border-radius: 100px;
}
.staffProgress__search_slqM1 input,
.staffProgress__search_slqM1 button {
  background: #eeeff2;
}
.staffProgress__table__tittle_xvAHD {
  font-size: 14px;
  font-weight: 600;
  color: #444b50;
  text-align: center !important;
}
.calender__main__height_NJaMa {
  height: 420px;
}
.calender__tittle__main_NQhGt {
  display: flex;
  flex-direction: row;
}
.calender__tittle__header1_TfLZE {
  font-size: 16px;
  font-weight: 700;
  line-height: 32px;
}
.calender__tittle__header2_MNOJ7 {
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;
}
.calender__list__item_wVdJj {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  background-color: #ffffff;
}
.calender__list__item__time__col_r4wnv {
  display: flex;
  flex-direction: row;
}
.calender__list__item__time__value_onQS1 {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #8f9bb3;
  align-self: center;
}
.calender__list__item__tittle__value_XGZjl {
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  color: #364459;
}
.calender__list__item__sub__tittle__value_Z4ScU {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #8f9bb3;
  margin-top: 6px;
}
.calender__tag_A_4T2 {
  border-radius: 10px;
}
.myTask__tittle_NkpvB {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #364459;
}
.tab_QVEtH {
  cursor: pointer;
  color: #b6b7b9;
  /* Default color */
  font-weight: bold;
  padding: 0 5px;
  font-size: 16px;
}
.tab_QVEtH.active_WW9z6 {
  color: #666b71;
  /* Highlight active tab in blue */
}
.content_y02e8 {
  margin-top: 20px;
  font-size: 16px;
}
.myTask__add_drwN0 {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background-color: #306bff;
}
.myTask__select_GwHQT {
  width: 120px;
  background-color: #f6f6f6;
  border-radius: 10px;
}
.myTask__viewall_hlRUo {
  font-size: 14px;
  font-weight: 500;
  line-height: 10px;
  color: #306bff;
  text-align: center;
  -webkit-text-decoration: dotted underline;
          text-decoration: dotted underline;
}
.myTask__list__item_HYqVj {
  display: block !important;
  padding: 10px !important;
  margin: 5px 0px !important;
  background-color: #f0f6ff;
  border-radius: 10px;
  border: 0px;
  overflow-x: hidden !important;
}
.myTask__list__item__tittle_CO3j9 {
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  color: #364459;
}
.myTask__list__item__tag__one_Nfici {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  border-radius: 5px;
}
.myTask__list__item__status_muU1R {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 400;
  color: #b3b3b3;
}
.myTask__list__item__dot_fxONl {
  border-radius: 10px;
  height: 10px;
  width: 10px;
  place-self: center;
}
.myTask__list__itme__complete__status_mqByt {
  font-size: 11px;
  font-weight: 400;
  color: #344054 !important;
  border: 1px Solid #d0d5dd !important;
  padding: 1.5px 6px;
  border-radius: 8px;
}
.mobileRequest__tittle_HOme3 {
  font-size: 20px;
  font-weight: 600;
  align-self: center;
}
.mobileRequest__viewall_eI4yH {
  font-size: 14px;
  font-weight: 500;
  color: #306bff;
  text-align: right;
  align-self: center;
}
.moblieRequest__list__item_c4HWa {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  background-color: #f0f6ff;
}
.moblieRequest__list__item__dot_PfIpU {
  border-radius: 10px;
  height: 10px;
  width: 10px;
  place-self: center;
}
.moblieRequest__list__item__tittle__main_sDMES {
  display: flex;
  flex-direction: row;
}
.moblieRequest__list__item__tittle_UqwLg {
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
}
.moblieRequest__list__item__subtsittle__main_VnnjR {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #718096;
  margin-top: 8px;
}
.moblieRequest__list__item__subtsittle__col_zU92T {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.moblieRequest__list__item__subtsittle_Bpgz8 {
  font-size: 14px;
  font-weight: 600;
  color: #364459;
}
.toApprove__tittle_Vnl75 {
  font-size: 20px;
  font-weight: 600;
  align-self: center;
}
.project__viewall_S26WW {
  font-size: 14px;
  font-weight: 500;
  color: #306bff;
  text-align: right;
  align-self: center;
  cursor: pointer;
  -webkit-text-decoration: dotted underline;
          text-decoration: dotted underline;
}
.project__viewallcomplate_LH6wc {
  font-size: 12px;
}
.toApprove__list__item_suvoG {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e1e6f0;
}
.toApprove__list__item__permission_L253R {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  border-radius: 8px;
  border: 1px solid #e1e6f0;
  background-color: #ffffff;
}
.toApprove__list__item__timesheet_PqHVi {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e1e6f0;
}
.toApprove__list__item__tittle_Z6gBd {
  font-size: 15px;
  font-weight: 500;
  line-height: 15px;
  color: #383853;
  margin-left: 10px;
}
.toApprove__list__item__reason_mLuiL {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 5px;
  color: #36445980;
  margin-left: 10px;
}
.toApprove__list__item__leavetype_rmW5O {
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  color: #4d5770;
  background-color: #f3f8ff;
}
.toApprove__list__item__leaveday_v4m2l {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  background-color: #f3f8ff;
  color: #4d5770;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.toApprove__list__item__timesheet__duration_jrUcy {
  font-size: 12px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  background-color: #cee3c4;
  color: #316419;
}
.toApprove__list__item__button__main_n6_Sv {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 5px;
}
.toApprove__list__item__button__approve_aDwjP {
  background-color: #1a7f4f !important;
  border-radius: 4px;
  font-size: 11px;
  color: #ffffff;
}
.toApprove__list__item__button__approve_aDwjP:hover {
  background-color: white !important;
  color: black !important;
  border-color: green !important;
}
.toApprove__list__item__button__cancel__IIUH {
  background-color: #a61d24 !important;
  border-radius: 4px;
  font-size: 11px;
  color: #ffffff;
}
.toApprove__list__item__button__cancel__IIUH:hover {
  background-color: white !important;
  color: black !important;
  border-color: #ec2d38 !important;
}
.client__card__button_iOZ6d {
  background-color: #1f6edc;
  border-radius: 10px;
  font-size: 11px;
  color: #ffffff;
}
.client__card__buttonInactive_ogJiw {
  border-radius: 10px;
  font-optical-sizing: 11px;
}
.flexContainer_kFQAJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.custom_table_x9gRm td {
  text-align: center;
}
.custom_table_x9gRm th {
  text-align: center;
}
.project__list__item_wEsOw {
  display: block !important;
  padding: 10px !important;
  margin: 5px 0px !important;
  background-color: #ffffff;
  border-radius: 10px;
  border: 0px;
  overflow-x: hidden !important;
  cursor: pointer;
}
.project__list__item__tittle_du8Y0 {
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  color: #7f7c77;
}
.projectstaus__list__title_PLQn9 {
  cursor: pointer;
  color: #b6b7b9;
  /* Default color */
  font-weight: bold;
  padding: 0 5px;
  font-size: 16px;
}
.projectstaus__list__title_PLQn9.active_WW9z6 {
  color: #666b71;
  /* Highlight active tab in blue */
}
.projectstaus__list__item__tag__one_GSjSN {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  border-radius: 5px;
  top: 5px;
}
.projectstaus__last__item__main_Y3AiH {
  display: flex;
  flex-direction: column;
  text-align: end;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/ITDepartmetDashbord/Itindex.less"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,WAAA;AADJ;AAIA;EACI,aAAA;AAFJ;AAKA;EACI,aAAA;EACA,sBAAA;AAHJ;AAMA;EACI,gBAAA;AAJJ;AAOA;EACI,eAAA;AALJ;AAQA;EACI,kBAAA;AANJ;AASA;EACI,iBAAA;AAPJ;AAUA;EACI,aAAA;AARJ;AAWA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AATJ;AAYA;EACI,iBAAA;AAVJ;AAcA;EACI,8BAAA;AAZJ;AAeA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAbJ;AAgBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAdJ;AAiBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAfJ;AAkBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAhBJ;AAoBA;EACI,yBAAA;EACA,mBAAA;AAlBJ;AAqBA;EACI,WAAA;EACA,iBAAA;AAnBJ;AAsBA;EACI,uEAAA;EAEA,YAAA;EACA,WAAA;AArBJ;AAwBA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAtBJ;AAyBA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AAvBJ;AA0BA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAxBJ;AA2BA;EACI,gBAAA;EACA,cAAA;AAzBJ;AA4BA;EACI,iBAAA;AA1BJ;AA6BA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AA3BJ;AA8BA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AA5BJ;AA+BA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AA7BJ;AAgCA;EACI,iBAAA;EACA,gBAAA;AA9BJ;AAiCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA/BJ;AAkCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAhCJ;AAqCA;EACI,aAAA;AAnCJ;AAsCA;EACI,aAAA;AApCJ;AAsCA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AApCJ;AAuCA;EACI,eAAA;AArCJ;AAwCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAtCJ;AAyCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAvCJ;AA0CA;EACI,eAAA;AAxCJ;AA2CA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAzCJ;AA4CA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA1CJ;AA6CA;EACI,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA3CJ;AA8CA;EACI,eAAA;EACA,gBAAA;EAEA,yBAAA;EACA,iBAAA;AA7CJ;AAgDA;EACI,cAAA;EACA,gBAAA;AA9CJ;AAiDA;EACI,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AA/CJ;AAoDA;EACI,aAAA;AAlDJ;AAqDA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAnDJ;AAsDA;EACI,eAAA;AApDJ;AAuDA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AArDJ;AAwDA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAtDJ;AAyDA;EACI,eAAA;AAvDJ;AA0DA;EACI,gBAAA;AAxDJ;AA2DA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzDJ;AA4DA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA1DJ;AA6DA;EACI,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA3DJ;AAgEA;EACI,aAAA;AA9DJ;AAiEA;EACI,yBAAA;EACA,mBAAA;AA/DJ;AAkEA;EACI,aAAA;EACA,mBAAA;AAhEJ;AAmEA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAjEJ;AAoEA;EACI,aAAA;EACA,mBAAA;AAlEJ;AAqEA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AAnEJ;AAsEA;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AApEJ;AAuEA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AArEJ;AAwEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AAtEJ;AAyEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAvEJ;AA0EA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAxEJ;AA6EA;EACI,aAAA;AA3EJ;AA8EA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA5EJ;AA+EA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA7EJ;AAgFA;EACI,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA9EJ;AAiFA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA/EJ;AAkFA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAhFJ;AAmFA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAjFJ;AAoFA;EACI,WAAA;EACA,gBAAA;AAlFJ;AAqFA;EACI,WAAA;AAnFJ;AAsFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApFJ;AAuFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AArFJ;AAwFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAtFJ;AAyFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvFJ;AA0FA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAxFJ;AA2FA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AAzFJ;AA4FA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AA1FJ;AA6FA;EACI,eAAA;AA3FJ;AAgGA;EACI,aAAA;AA9FJ;AAiGA;EACI,YAAA;EACA,yBAAA;EACA,mBAAA;AA/FJ;AAkGA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAhGJ;AAmGA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAjGJ;AAmGA;EACI,yBAAA;AAjGJ;AAoGA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAlGJ;AAqGA;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;AAnGJ;AAsGA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,kBAAA;AApGJ;AAuGA;EACI,eAAA;EACA,gBAAA;AArGJ;AAuGA;EACI,eAAA;EACA,gBAAA;EACA,0CAAA;UAAA,kCAAA;AArGJ;AAyGA;EACI,YAAA;AAvGJ;AA0GA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAxGJ;AA2GA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAzGJ;AA4GA;EACI,gBAAA;EACA,WAAA;AA1GJ;AA6GA;EACI,YAAA;EACA,gBAAA;EACA,oBAAA;AA3GJ;AAwGA;;EAMQ,mBAAA;AA1GR;AA8GA;EACI,eAAA;EACA,gBAAA;EAEA,cAAA;EACA,6BAAA;AA7GJ;AAkHA;EACI,aAAA;AAhHJ;AAmHA;EACI,aAAA;EACA,mBAAA;AAjHJ;AAoHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAlHJ;AAqHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAnHJ;AAsHA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;AApHJ;AAuHA;EACI,aAAA;EACA,mBAAA;AArHJ;AAwHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAtHJ;AAyHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAvHJ;AA0HA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAxHJ;AA2HA;EACI,mBAAA;AAzHJ;AA6HA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA3HJ;AA8HA;EACI,eAAA;EACA,cAAA;EA5HF,kBAAkB;EA6HhB,iBAAA;EACA,cAAA;EACA,eAAA;AA3HJ;AA8HA;EACI,cAAA;EA5HF,iCAAiC;AACnC;AA8HA;EACI,gBAAA;EACA,eAAA;AA5HJ;AA+HA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA7HJ;AAgIA;EACI,YAAA;EACA,yBAAA;EACA,mBAAA;AA9HJ;AAiIA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;UAAA,iCAAA;AA/HJ;AAkIA;EACI,yBAAA;EACA,wBAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;AAhIJ;AAmIA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAjIJ;AAoIA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAlIJ;AAqIA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnIJ;AAsIA;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AApIJ;AAuIA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;AArIJ;AA0IA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAxIJ;AA2IA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAzIJ;AA4IA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;AA1IJ;AA6IA;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AA3IJ;AA8IA;EACI,aAAA;EACA,mBAAA;AA5IJ;AA+IA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AA7IJ;AAgJA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA9IJ;AAiJA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;AA/IJ;AAkJA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAhJJ;AAqJA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAnJJ;AAsJA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;UAAA,iCAAA;AApJJ;AAsJA;EACI,eAAA;AApJJ;AAuJA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AArJJ;AAwJA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAtJJ;AAyJA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAvJJ;AAyJA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAvJJ;AA0JA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAxJJ;AA2JA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AAzJJ;AA4JA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AA1JJ;AA6JA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AA3JJ;AA8JA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA5JJ;AA+JA;EACI,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA7JJ;AA+JA;EACI,kCAAA;EACA,uBAAA;EACA,8BAAA;AA7JJ;AAgKA;EACI,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA9JJ;AAgKA;EACI,kCAAA;EACA,uBAAA;EACA,gCAAA;AA9JJ;AAgKA;EACI,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AA9JJ;AAgKA;EACI,mBAAA;EACA,yBAAA;AA9JJ;AAgKA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AA9JJ;AAiKA;EACI,kBAAA;AA/JJ;AAkKA;EACI,kBAAA;AAhKJ;AAmKA;EACI,yBAAA;EACA,wBAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;AAjKJ;AAmKA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAjKJ;AAmKA;EACI,eAAA;EACA,cAAA;EAjKF,kBAAkB;EAkKhB,iBAAA;EACA,cAAA;EACA,eAAA;AAhKJ;AAmKA;EACI,cAAA;EAjKF,iCAAiC;AACnC;AAmKA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AAjKJ;AAmKA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AAjKJ","sourcesContent":["// commont css\n\n.card {\n    margin-top: 10px;\n    width: 100%;\n}\n\n.cardContent {\n    margin: -10px;\n}\n\n.col {\n    display: flex;\n    flex-direction: column;\n}\n\n.marginTop10 {\n    margin-top: 10px;\n}\n\n.marginTop5 {\n    margin-top: 5px;\n}\n\n.marginRight10 {\n    margin-right: 10px;\n}\n\n.marginLeft10 {\n    margin-left: 10px;\n}\n\n.displayflex {\n    display: flex;\n}\n\n.tittle {\n    font-size: 24px;\n    font-weight: 600;\n    color: #3a3541;\n    margin-top: 0px;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n// welcome component css\n.welcome {\n    justify-content: space-between;\n}\n\n.welcome__div {\n    display: flex;\n    flex-direction: row;\n    margin-top: 0px;\n    font-size: 18px;\n}\n\n.welcome__div__largeText {\n    font-size: 16px;\n    color: #718096;\n    font-weight: 600;\n    margin: auto;\n}\n\n.welcome__div__largeText_name {\n    font-size: 16px;\n    color: #306bff;\n    font-weight: 600;\n}\n\n.welcome__div__smallText {\n    font-size: 14px;\n    color: #4d5770;\n    font-weight: 500;\n    margin: auto;\n}\n\n// headLines component css\n.headLines__left {\n    background-color: #e8f1ff;\n    border-radius: 10px;\n}\n\n.headLines__left__textDivOne {\n    width: 100%;\n    margin-left: 10px;\n}\n\n.headLines__left__textDiv__backgroundImage {\n    background: url('../../../Assest/Svg/DashboardWelcomeImg.svg') no-repeat -75%\n        140%;\n    height: 100%;\n    width: 100%;\n}\n\n.headLines__left__textDivOne_text {\n    font-weight: 500;\n    font-size: 16px;\n    color: #1a1d3c;\n}\n\n.headLines__left__textDivTwo {\n    width: 100%;\n    margin-left: 10px;\n    margin-top: -10px;\n}\n\n.headLines__left__textDivTwo_text {\n    font-weight: 500;\n    font-size: 12px;\n    color: #4d5770;\n}\n\n.headLines__left__textDivOne__text__name {\n    font-weight: 700;\n    color: #ffc061;\n}\n\n.headLines__right {\n    max-height: 124px;\n}\n\n.headLines__right__row {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: start;\n    margin-left: 20px;\n    margin-bottom: 0px;\n}\n\n.headLines__right__row__headline {\n    font-size: 20px;\n    font-weight: 600;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    color: #25396f;\n    line-height: 32px;\n}\n\n.headLines__right__row__headline__arrow {\n    position: absolute;\n    right: 0px;\n    top: 2px;\n}\n\n.headLines__right__row__headline__arrow__button {\n    display: contents;\n    margin-top: auto;\n}\n\n.headLines__right__row__tittle {\n    font-size: 16px;\n    font-weight: 600;\n    color: #364459;\n    margin-bottom: 0px;\n}\n\n.headLines__right__row__description {\n    font-size: 16px;\n    font-weight: 400;\n    color: #667085;\n    margin-bottom: 0px;\n}\n\n//clients component css\n\n.client__card__height {\n    height: 320px;\n}\n\n.over__card__height {\n    height: 360px;\n}\n.clients__first__left {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 24px;\n    color: #364459;\n    padding-right: 10px;\n}\n\n.client__first__middle {\n    text-align: end;\n}\n\n.client__first__middle__text {\n    font-size: 14px;\n    font-weight: 700;\n    color: #718096;\n    margin-top: 15px;\n}\n\n.client__first__middle__count {\n    font-size: 24px;\n    font-weight: 700;\n    color: #25396f;\n    margin-top: 3px;\n    margin-left: 10px;\n}\n\n.client__first__right {\n    text-align: end;\n}\n\n.client__second {\n    display: flex;\n    flex-direction: row;\n    margin-top: 6px;\n    overflow-wrap: anywhere;\n}\n\n.client__second__col {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.client__second__number {\n    text-align: center !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2px;\n}\n\n.client__second__number__tag {\n    font-size: 11px;\n    font-weight: 600;\n    //border-radius: 10px;\n    color: #000000 !important;\n    line-height: 14px;\n}\n\n.client__second__name {\n    font-size: 1px;\n    font-weight: 500;\n}\n\n.client__third {\n    position: relative;\n    height: 100% !important;\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: 10px;\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n//Missing Info Component CSS\n\n.missingInfo__main__height {\n    height: 360px;\n}\n\n.missingInfo__first__left {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n    color: #364459;\n    margin-top: -10px;\n}\n\n.missingInfo__first__middle {\n    text-align: end;\n}\n\n.missingInfo__first__middle__text {\n    font-size: 14px;\n    font-weight: 700;\n    color: #718096;\n}\n\n.missingInfo__first__middle__count {\n    font-size: 24px;\n    font-weight: 700;\n    color: #25396f;\n    margin-top: -5px;\n}\n\n.missingInfo__first__right {\n    text-align: end;\n}\n\n.missingInfo__second {\n    margin-top: 20px;\n}\n\n.missingInfo__second__row {\n    font: caption;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.missingInfo__second__row__first__col {\n    font-size: 14px;\n    color: #33529a;\n    font-weight: 500;\n    line-height: 17px;\n}\n\n.missingInfo__second__row__second__col {\n    text-align: end;\n    font-size: 18px;\n    color: #49849d;\n    font-weight: 600;\n    line-height: 22px;\n}\n\n//Invoice and credit controller CSS\n\n.icController__main__height {\n    height: 360px;\n}\n\n.icController__select {\n    background-color: #f6f6f6;\n    border-radius: 10px;\n}\n\n.icController__first {\n    display: flex;\n    align-items: center;\n}\n\n.icController__first__tittle {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    color: #364459;\n}\n\n.icController__second {\n    display: flex;\n    align-items: center;\n}\n\n.icController__third {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\n\n.icController__chart__first {\n    margin-top: 10px;\n    align-content: center;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    top: 0%;\n    left: 0%;\n}\n\n.icController__chart__second {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-wrap: nowrap;\n    margin-top: 10px;\n}\n\n.icController__chart__second__col {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: 0 10px;\n}\n\n.icController__chart__second__col__firstDiv {\n    font-size: 13px;\n    font-weight: 400;\n    color: #83838d;\n    text-align: center;\n}\n\n.icController__chart__second__col__secondDiv {\n    font-size: 20px;\n    font-weight: 500;\n    color: #47484a;\n    text-align: center;\n}\n\n// To do Component CSS\n\n.todo__main__height {\n    height: 800px;\n}\n\n.todo__tab__one {\n    margin-top: 20px;\n    color: #4d5770;\n    font-weight: 500;\n    font-size: 10px;\n}\n\n.todo__tab__one__tag {\n    width: 70px;\n    height: 20px;\n    color: #364459;\n    text-align: center;\n    border-radius: 10px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.todo__tab__one__badge {\n    height: 10px;\n    color: #364459;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.todo__tab__two__main__active {\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 20px;\n    color: #306bff;\n    cursor: pointer;\n}\n\n.todo__tab__two__main__inactive {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #a0aec0;\n    cursor: pointer;\n}\n\n.todo__tab__two__main__right {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    color: #306bff;\n    text-align: end;\n    cursor: pointer;\n}\n\n.todo__list__main {\n    width: 100%;\n    margin-top: 10px;\n}\n\n.todo__list__main__item__main {\n    width: 100%;\n}\n\n.todo__list__main__item__main__tittle {\n    width: 100%;\n    font-size: 14px;\n    font-weight: 600;\n    color: #364459;\n}\n\n.todo__list__main__item__main__first__content {\n    width: 100%;\n    font-size: 12px;\n    font-weight: 400;\n    color: #718096;\n    margin-bottom: 6px;\n    margin-top: 6px;\n}\n\n.todo__list__second__item__tittle {\n    width: 100%;\n    font-size: 12px;\n    font-weight: 400;\n    color: #718096;\n    margin-bottom: 6px;\n    margin-top: 6px;\n}\n\n.todo__list__third__item__first__tittle {\n    width: 100%;\n    font-size: 11px;\n    font-weight: 400;\n    color: #718096;\n}\n\n.todo__list__third__item__second__tittle {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    font-size: 10px;\n    font-weight: 400;\n    color: #718096;\n}\n\n.todo__last__item__main {\n    display: flex;\n    flex-direction: column;\n    text-align: end;\n}\n\n.todo__last__item__button {\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 23px;\n    align-self: flex-end;\n}\n\n.todo__last__item__icons {\n    margin-top: 5px;\n}\n\n//To Follow Css\n\n.toFollow__main__height {\n    height: 440px;\n}\n\n.toFollow__select {\n    width: 120px;\n    background-color: #f6f6f6;\n    border-radius: 10px;\n}\n\n.toFollow__viewAll {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    color: #306bff;\n    text-align: end;\n    cursor: pointer;\n}\n\n.toFollow__tab__active {\n    font-size: 13px;\n    font-weight: 400;\n    color: #ffffff;\n}\n.toFollow__tag__active {\n    background-color: #3e8eff;\n}\n\n.toFollow__tab__inactive {\n    font-size: 13px;\n    font-weight: 400;\n    color: #1a1d3c;\n    padding: 2px !important;\n}\n\n.toFollow__chart__main {\n    margin-top: 10px;\n    align-content: center;\n    position: relative;\n    width: 100%;\n    height: 200px;\n    top: 0%;\n    left: 0%;\n}\n\n.toFollow__chart__text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #364459;\n    text-align: center;\n}\n\n.toFollow__chart__text_count {\n    font-size: 20px;\n    font-weight: 500;\n}\n.toFollow__chart__text_count_text {\n    font-size: 15px;\n    font-weight: 400;\n    text-decoration: dashed !important;\n}\n//staff progress css\n\n.staffProgress__main__height {\n    height: auto;\n}\n\n.staffProgress__tittle {\n    font-size: 20px;\n    font-weight: 600;\n    color: #364459;\n    line-height: 32px;\n}\n\n.staffProgress__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    color: #306bff;\n    line-height: 20px;\n    align-self: center;\n    text-align: end;\n    cursor: pointer;\n}\n\n.staffProgress__table {\n    margin-top: 10px;\n    width: 100%;\n}\n\n.staffProgress__search {\n    width: 350px;\n    margin-top: 10px;\n    border-radius: 100px;\n    input,\n    button {\n        background: #eeeff2;\n    }\n}\n\n.staffProgress__table__tittle {\n    font-size: 14px;\n    font-weight: 600;\n    // line-height: 24px;\n    color: #444b50;\n    text-align: center !important;\n}\n\n// calender component Css\n\n.calender__main__height {\n    height: 420px;\n}\n\n.calender__tittle__main {\n    display: flex;\n    flex-direction: row;\n}\n\n.calender__tittle__header1 {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 32px;\n}\n\n.calender__tittle__header2 {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 32px;\n}\n\n.calender__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    background-color: #ffffff;\n}\n\n.calender__list__item__time__col {\n    display: flex;\n    flex-direction: row;\n}\n\n.calender__list__item__time__value {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    color: #8f9bb3;\n    align-self: center;\n}\n\n.calender__list__item__tittle__value {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19px;\n    color: #364459;\n}\n\n.calender__list__item__sub__tittle__value {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    color: #8f9bb3;\n    margin-top: 6px;\n}\n\n.calender__tag {\n    border-radius: 10px;\n}\n\n//myTask Component Css\n.myTask__tittle {\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 600;\n    color: #364459;\n}\n\n.tab {\n    cursor: pointer;\n    color: #b6b7b9; /* Default color */\n    font-weight: bold;\n    padding: 0 5px;\n    font-size: 16px;\n}\n\n.tab.active {\n    color: #666b71; /* Highlight active tab in blue */\n}\n\n.content {\n    margin-top: 20px;\n    font-size: 16px;\n}\n\n.myTask__add {\n    font-size: 14px;\n    font-weight: 500;\n    color: #ffffff;\n    background-color: #306bff;\n}\n\n.myTask__select {\n    width: 120px;\n    background-color: #f6f6f6;\n    border-radius: 10px;\n}\n\n.myTask__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 10px;\n    color: #306bff;\n    text-align: center;\n    text-decoration: dotted underline;\n}\n\n.myTask__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px 0px !important;\n    background-color: #f0f6ff;\n    border-radius: 10px;\n    border: 0px;\n    overflow-x: hidden !important;\n}\n\n.myTask__list__item__tittle {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19px;\n    color: #364459;\n}\n\n.myTask__list__item__tag__one {\n    font-size: 12px;\n    font-weight: 400;\n    color: #ffffff;\n    border-radius: 5px;\n}\n\n.myTask__list__item__status {\n    display: flex;\n    flex-direction: row;\n    font-size: 12px;\n    font-weight: 400;\n    color: #b3b3b3;\n}\n\n.myTask__list__item__dot {\n    border-radius: 10px;\n    height: 10px;\n    width: 10px;\n    place-self: center;\n}\n\n.myTask__list__itme__complete__status {\n    font-size: 11px;\n    font-weight: 400;\n    color: #344054 !important;\n    border: 1px Solid #d0d5dd !important;\n    padding: 1.5px 6px;\n    border-radius: 8px;\n}\n\n//mobile Request Component Css\n\n.mobileRequest__tittle {\n    font-size: 20px;\n    font-weight: 600;\n    align-self: center;\n}\n\n.mobileRequest__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    color: #306bff;\n    text-align: right;\n    align-self: center;\n}\n\n.moblieRequest__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    background-color: #f0f6ff;\n}\n\n.moblieRequest__list__item__dot {\n    border-radius: 10px;\n    height: 10px;\n    width: 10px;\n    place-self: center;\n}\n\n.moblieRequest__list__item__tittle__main {\n    display: flex;\n    flex-direction: row;\n}\n\n.moblieRequest__list__item__tittle {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 17px;\n}\n\n.moblieRequest__list__item__subtsittle__main {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    color: #718096;\n    margin-top: 8px;\n}\n\n.moblieRequest__list__item__subtsittle__col {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n}\n\n.moblieRequest__list__item__subtsittle {\n    font-size: 14px;\n    font-weight: 600;\n    color: #364459;\n}\n\n//To Approve Component CSS\n\n.toApprove__tittle {\n    font-size: 20px;\n    font-weight: 600;\n    align-self: center;\n}\n\n.project__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    color: #306bff;\n    text-align: right;\n    align-self: center;\n    cursor: pointer;\n    text-decoration: dotted underline;\n}\n.project__viewallcomplate {\n    font-size: 12px;\n}\n\n.toApprove__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    border-radius: 8px;\n    background-color: #ffffff;\n    border: 1px solid #e1e6f0;\n}\n\n.toApprove__list__item__permission {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    border-radius: 8px;\n    border: 1px solid #e1e6f0;\n    background-color: #ffffff;\n}\n\n.toApprove__list__item__timesheet {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    border-radius: 8px;\n    background-color: #ffffff;\n    border: 1px solid #e1e6f0;\n}\n.toApprove__list__item__tittle {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 15px;\n    color: #383853;\n    margin-left: 10px;\n}\n\n.toApprove__list__item__reason {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    margin-top: 5px;\n    color: #36445980;\n    margin-left: 10px;\n}\n\n.toApprove__list__item__leavetype {\n    font-size: 12px;\n    font-weight: 500;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    color: #4d5770;\n    background-color: #f3f8ff;\n}\n\n.toApprove__list__item__leaveday {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    background-color: #f3f8ff;\n    color: #4d5770;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n}\n\n.toApprove__list__item__timesheet__duration {\n    font-size: 12px;\n    font-weight: 500;\n    border: none;\n    border-radius: 4px;\n    background-color: #cee3c4;\n    color: #316419;\n}\n\n.toApprove__list__item__button__main {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 5px;\n}\n\n.toApprove__list__item__button__approve {\n    background-color: #1a7f4f !important;\n    border-radius: 4px;\n    font-size: 11px;\n    color: #ffffff;\n}\n.toApprove__list__item__button__approve:hover {\n    background-color: white !important;\n    color: black !important;\n    border-color: green !important;\n}\n\n.toApprove__list__item__button__cancel {\n    background-color: #a61d24 !important;\n    border-radius: 4px;\n    font-size: 11px;\n    color: #ffffff;\n}\n.toApprove__list__item__button__cancel:hover {\n    background-color: white !important;\n    color: black !important;\n    border-color: #ec2d38 !important;\n}\n.client__card__button {\n    background-color: #1f6edc;\n    border-radius: 10px;\n    font-size: 11px;\n    color: #ffffff;\n}\n.client__card__buttonInactive {\n    border-radius: 10px;\n    font-optical-sizing: 11px;\n}\n.flexContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.custom_table td {\n    text-align: center;\n}\n\n.custom_table th {\n    text-align: center;\n}\n\n.project__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px 0px !important;\n    background-color: #ffffff;\n    border-radius: 10px;\n    border: 0px;\n    overflow-x: hidden !important;\n    cursor: pointer;\n}\n.project__list__item__tittle {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 19px;\n    color: #7f7c77;\n}\n.projectstaus__list__title {\n    cursor: pointer;\n    color: #b6b7b9; /* Default color */\n    font-weight: bold;\n    padding: 0 5px;\n    font-size: 16px;\n}\n\n.projectstaus__list__title.active {\n    color: #666b71; /* Highlight active tab in blue */\n}\n\n.projectstaus__list__item__tag__one {\n    font-size: 12px;\n    font-weight: 400;\n    color: #ffffff;\n    border-radius: 5px;\n    top: 5px;\n}\n.projectstaus__last__item__main {\n    display: flex;\n    flex-direction: column;\n    text-align: end;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_I0fOc`,
	"cardContent": `cardContent_fSc1A`,
	"col": `col_FfKf7`,
	"marginTop10": `marginTop10_TOexI`,
	"marginTop5": `marginTop5_oGoGi`,
	"marginRight10": `marginRight10_TPJhB`,
	"marginLeft10": `marginLeft10_ACTtz`,
	"displayflex": `displayflex_mBYNn`,
	"tittle": `tittle_NTplU`,
	"textAlignRight": `textAlignRight_C5FAk`,
	"welcome": `welcome_N9WQ5`,
	"welcome__div": `welcome__div_QpU1C`,
	"welcome__div__largeText": `welcome__div__largeText_rAxQE`,
	"welcome__div__largeText_name": `welcome__div__largeText_name_TgYm1`,
	"welcome__div__smallText": `welcome__div__smallText_SWjNL`,
	"headLines__left": `headLines__left_iZGmF`,
	"headLines__left__textDivOne": `headLines__left__textDivOne_Oxjjs`,
	"headLines__left__textDiv__backgroundImage": `headLines__left__textDiv__backgroundImage_IVivW`,
	"headLines__left__textDivOne_text": `headLines__left__textDivOne_text_Gd1V4`,
	"headLines__left__textDivTwo": `headLines__left__textDivTwo_HCKfc`,
	"headLines__left__textDivTwo_text": `headLines__left__textDivTwo_text_eVZB5`,
	"headLines__left__textDivOne__text__name": `headLines__left__textDivOne__text__name_yUMgK`,
	"headLines__right": `headLines__right_orC2C`,
	"headLines__right__row": `headLines__right__row_Veu6q`,
	"headLines__right__row__headline": `headLines__right__row__headline_dbiXU`,
	"headLines__right__row__headline__arrow": `headLines__right__row__headline__arrow_n4Hko`,
	"headLines__right__row__headline__arrow__button": `headLines__right__row__headline__arrow__button_FZbjc`,
	"headLines__right__row__tittle": `headLines__right__row__tittle_fkrf1`,
	"headLines__right__row__description": `headLines__right__row__description_IHgX5`,
	"client__card__height": `client__card__height_wMLsv`,
	"over__card__height": `over__card__height_LCG6I`,
	"clients__first__left": `clients__first__left_uxDsu`,
	"client__first__middle": `client__first__middle_g_pZi`,
	"client__first__middle__text": `client__first__middle__text_hxXqT`,
	"client__first__middle__count": `client__first__middle__count_g1e6D`,
	"client__first__right": `client__first__right_QM8Ht`,
	"client__second": `client__second_n4hFc`,
	"client__second__col": `client__second__col_PQ5GH`,
	"client__second__number": `client__second__number_M5m5b`,
	"client__second__number__tag": `client__second__number__tag_AczVz`,
	"client__second__name": `client__second__name_MS1x4`,
	"client__third": `client__third_hZASb`,
	"missingInfo__main__height": `missingInfo__main__height_gui5y`,
	"missingInfo__first__left": `missingInfo__first__left_ZSFd6`,
	"missingInfo__first__middle": `missingInfo__first__middle_M4gJw`,
	"missingInfo__first__middle__text": `missingInfo__first__middle__text_XftXh`,
	"missingInfo__first__middle__count": `missingInfo__first__middle__count_sapfx`,
	"missingInfo__first__right": `missingInfo__first__right_qAx_W`,
	"missingInfo__second": `missingInfo__second_R2vpQ`,
	"missingInfo__second__row": `missingInfo__second__row_hv_au`,
	"missingInfo__second__row__first__col": `missingInfo__second__row__first__col_KAnop`,
	"missingInfo__second__row__second__col": `missingInfo__second__row__second__col_Ivsyn`,
	"icController__main__height": `icController__main__height_UjNXV`,
	"icController__select": `icController__select_Cd6fy`,
	"icController__first": `icController__first_s0xC2`,
	"icController__first__tittle": `icController__first__tittle_Au_ro`,
	"icController__second": `icController__second_u3HBc`,
	"icController__third": `icController__third_ynVMf`,
	"icController__chart__first": `icController__chart__first_BoVqO`,
	"icController__chart__second": `icController__chart__second_s5we2`,
	"icController__chart__second__col": `icController__chart__second__col_mUDKO`,
	"icController__chart__second__col__firstDiv": `icController__chart__second__col__firstDiv_Js6ku`,
	"icController__chart__second__col__secondDiv": `icController__chart__second__col__secondDiv_nIDtZ`,
	"todo__main__height": `todo__main__height_5htUW`,
	"todo__tab__one": `todo__tab__one_aVuxt`,
	"todo__tab__one__tag": `todo__tab__one__tag_uScC5`,
	"todo__tab__one__badge": `todo__tab__one__badge_leGt_`,
	"todo__tab__two__main__active": `todo__tab__two__main__active_L_QTH`,
	"todo__tab__two__main__inactive": `todo__tab__two__main__inactive_DjwkT`,
	"todo__tab__two__main__right": `todo__tab__two__main__right_OcdMd`,
	"todo__list__main": `todo__list__main_QCWuL`,
	"todo__list__main__item__main": `todo__list__main__item__main_s8FSA`,
	"todo__list__main__item__main__tittle": `todo__list__main__item__main__tittle_X_C5R`,
	"todo__list__main__item__main__first__content": `todo__list__main__item__main__first__content_NQuNS`,
	"todo__list__second__item__tittle": `todo__list__second__item__tittle_MsupX`,
	"todo__list__third__item__first__tittle": `todo__list__third__item__first__tittle_SJINp`,
	"todo__list__third__item__second__tittle": `todo__list__third__item__second__tittle_O13Bk`,
	"todo__last__item__main": `todo__last__item__main_ZDKGi`,
	"todo__last__item__button": `todo__last__item__button_MQCku`,
	"todo__last__item__icons": `todo__last__item__icons_bMRQy`,
	"toFollow__main__height": `toFollow__main__height_rnxYk`,
	"toFollow__select": `toFollow__select_IP46D`,
	"toFollow__viewAll": `toFollow__viewAll_xXKJy`,
	"toFollow__tab__active": `toFollow__tab__active_cgs22`,
	"toFollow__tag__active": `toFollow__tag__active_QkygL`,
	"toFollow__tab__inactive": `toFollow__tab__inactive_hzQCC`,
	"toFollow__chart__main": `toFollow__chart__main_GOnIQ`,
	"toFollow__chart__text": `toFollow__chart__text_FINzq`,
	"toFollow__chart__text_count": `toFollow__chart__text_count_oryGK`,
	"toFollow__chart__text_count_text": `toFollow__chart__text_count_text___8Py`,
	"staffProgress__main__height": `staffProgress__main__height_BBQvs`,
	"staffProgress__tittle": `staffProgress__tittle_l8sji`,
	"staffProgress__viewall": `staffProgress__viewall_P895S`,
	"staffProgress__table": `staffProgress__table_V1FOJ`,
	"staffProgress__search": `staffProgress__search_slqM1`,
	"staffProgress__table__tittle": `staffProgress__table__tittle_xvAHD`,
	"calender__main__height": `calender__main__height_NJaMa`,
	"calender__tittle__main": `calender__tittle__main_NQhGt`,
	"calender__tittle__header1": `calender__tittle__header1_TfLZE`,
	"calender__tittle__header2": `calender__tittle__header2_MNOJ7`,
	"calender__list__item": `calender__list__item_wVdJj`,
	"calender__list__item__time__col": `calender__list__item__time__col_r4wnv`,
	"calender__list__item__time__value": `calender__list__item__time__value_onQS1`,
	"calender__list__item__tittle__value": `calender__list__item__tittle__value_XGZjl`,
	"calender__list__item__sub__tittle__value": `calender__list__item__sub__tittle__value_Z4ScU`,
	"calender__tag": `calender__tag_A_4T2`,
	"myTask__tittle": `myTask__tittle_NkpvB`,
	"tab": `tab_QVEtH`,
	"active": `active_WW9z6`,
	"content": `content_y02e8`,
	"myTask__add": `myTask__add_drwN0`,
	"myTask__select": `myTask__select_GwHQT`,
	"myTask__viewall": `myTask__viewall_hlRUo`,
	"myTask__list__item": `myTask__list__item_HYqVj`,
	"myTask__list__item__tittle": `myTask__list__item__tittle_CO3j9`,
	"myTask__list__item__tag__one": `myTask__list__item__tag__one_Nfici`,
	"myTask__list__item__status": `myTask__list__item__status_muU1R`,
	"myTask__list__item__dot": `myTask__list__item__dot_fxONl`,
	"myTask__list__itme__complete__status": `myTask__list__itme__complete__status_mqByt`,
	"mobileRequest__tittle": `mobileRequest__tittle_HOme3`,
	"mobileRequest__viewall": `mobileRequest__viewall_eI4yH`,
	"moblieRequest__list__item": `moblieRequest__list__item_c4HWa`,
	"moblieRequest__list__item__dot": `moblieRequest__list__item__dot_PfIpU`,
	"moblieRequest__list__item__tittle__main": `moblieRequest__list__item__tittle__main_sDMES`,
	"moblieRequest__list__item__tittle": `moblieRequest__list__item__tittle_UqwLg`,
	"moblieRequest__list__item__subtsittle__main": `moblieRequest__list__item__subtsittle__main_VnnjR`,
	"moblieRequest__list__item__subtsittle__col": `moblieRequest__list__item__subtsittle__col_zU92T`,
	"moblieRequest__list__item__subtsittle": `moblieRequest__list__item__subtsittle_Bpgz8`,
	"toApprove__tittle": `toApprove__tittle_Vnl75`,
	"project__viewall": `project__viewall_S26WW`,
	"project__viewallcomplate": `project__viewallcomplate_LH6wc`,
	"toApprove__list__item": `toApprove__list__item_suvoG`,
	"toApprove__list__item__permission": `toApprove__list__item__permission_L253R`,
	"toApprove__list__item__timesheet": `toApprove__list__item__timesheet_PqHVi`,
	"toApprove__list__item__tittle": `toApprove__list__item__tittle_Z6gBd`,
	"toApprove__list__item__reason": `toApprove__list__item__reason_mLuiL`,
	"toApprove__list__item__leavetype": `toApprove__list__item__leavetype_rmW5O`,
	"toApprove__list__item__leaveday": `toApprove__list__item__leaveday_v4m2l`,
	"toApprove__list__item__timesheet__duration": `toApprove__list__item__timesheet__duration_jrUcy`,
	"toApprove__list__item__button__main": `toApprove__list__item__button__main_n6_Sv`,
	"toApprove__list__item__button__approve": `toApprove__list__item__button__approve_aDwjP`,
	"toApprove__list__item__button__cancel": `toApprove__list__item__button__cancel__IIUH`,
	"client__card__button": `client__card__button_iOZ6d`,
	"client__card__buttonInactive": `client__card__buttonInactive_ogJiw`,
	"flexContainer": `flexContainer_kFQAJ`,
	"custom_table": `custom_table_x9gRm`,
	"project__list__item": `project__list__item_wEsOw`,
	"project__list__item__tittle": `project__list__item__tittle_du8Y0`,
	"projectstaus__list__title": `projectstaus__list__title_PLQn9`,
	"projectstaus__list__item__tag__one": `projectstaus__list__item__tag__one_GSjSN`,
	"projectstaus__last__item__main": `projectstaus__last__item__main_Y3AiH`
};
export default ___CSS_LOADER_EXPORT___;
